import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import Paper from '@mui/material/Paper';
import Bs4Kartoteka from '../Bs4Kartoteka'
import Bs4Draggable from './Bs4Draggable'
import { mouseOverSnackbar } from '../Bs4Snackbar'

function PaperComponent(props) {    
  const ref = React.useRef(null);
  const theme = useTheme() 

  return (
    <Bs4Draggable refElement={ref} refHeader={props.refheader}>
      <Paper 
        {...props}         
        sx={{
          position: 'absolute', 
          resize:'both',           
          ...props.sx, 
          overflow: 'hidden'
        }}
        ref={ref}        
      />
    </Bs4Draggable>
  );
}

export default function Bs4Diaog (props) {  
  const [visibility, setVisibility] = React.useState(Bs4Kartoteka.get(props.bs4KartotekaId)?.visibility || true);

  const handleClose = (event, reason) => {
    if (mouseOverSnackbar) return;
    if (props?.onClose) props.onClose(event, reason);
  }

  const handleKeyDown = (event) => {
    if (props.onKeyDown) props.onKeyDown(event);
  }

  React.useEffect(() => {
    if (!props.bs4KartotekaId) {
      return;
    }

    const bs4Kartoteka = Bs4Kartoteka.get(props.bs4KartotekaId);
    bs4Kartoteka.on(Bs4Kartoteka.CHANGE_VISIBILITY, setVisibility);

    return () => {
      const bs4Kartoteka = Bs4Kartoteka.get(props.bs4KartotekaId);
      if (bs4Kartoteka) bs4Kartoteka.off(setVisibility);
    }
  }, [props.bs4KartotekaId, setVisibility])
    
  /// zbadać /// <Modal open={props.open && visibility} keepMounted >
  const open = props.open && visibility;
  const maxWidth = props.maxWidth ? {maxWidth: props.maxWidth} : null;
  
  return (        
    <Dialog
      PaperComponent={PaperComponent}
      slotProps={{paper: {
        refheader: props.refHeader, 
        ...props.PaperProps,         
      }}}
      // maxWidth={props.maxWidth ? props.maxWidth : false}
      fullScreen={Boolean(props.fullScreen)}
      {...maxWidth}
      open={open} 
      sx={{
        visibility: open ? Bs4Kartoteka.VISIBILITY_VISIBLE : Bs4Kartoteka.VISIBILITY_HIDDEN,
        ...(props.sx || null)
      }} 
      keepMounted 
      fullWidth={Boolean(props.fullWidth)}
      hideBackdrop={props.hideBackdrop}
      onClose={handleClose}
      onKeyDown={handleKeyDown}
    >       
      {props.children}
    </Dialog>
  );
}